import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import {
  DateRangeFormComponent,
  IsoDateSelectorComponent,
  NgCommonModule,
} from '@principle-theorem/ng-shared';
import {
  ACC_BOOLEAN_DISPLAY_MAP,
  ACC_WORK_TYPE_MAP,
  AccBooleanValue,
  AccIncapacityType,
  AccPhysicalRestriction,
} from '@principle-theorem/principle-core/interfaces';
import { toOptions } from '@principle-theorem/shared';
import * as moment from 'moment-timezone';
import { AccWorkCapacityFormGroup } from '../../form-groups/acc-work-capacity.formgroup';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'pr-acc-work-capacity-form',
  imports: [
    NgCommonModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatDividerModule,
    MatIconModule,
    DateRangeFormComponent,
    IsoDateSelectorComponent,
    MatButtonModule,
  ],
  templateUrl: './acc-work-capacity-form.component.html',
  styleUrl: './acc-work-capacity-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccWorkCapacityFormComponent {
  form = input.required<AccWorkCapacityFormGroup>();
  disabled = input<boolean>(false);

  from = moment().startOf('day');
  to = moment().endOf('day').add(1, 'week');

  readonly booleanOptions = toOptions(AccBooleanValue);
  readonly booleanDisplay = ACC_BOOLEAN_DISPLAY_MAP;
  readonly incapacityTypeOptions = toOptions(AccIncapacityType);
  readonly workTypeOptions = toOptions(ACC_WORK_TYPE_MAP);
  readonly physicalRestrictionOptions = toOptions(AccPhysicalRestriction);
}
